exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1{margin-top:22px;margin-bottom:22px;padding:15px 20px 15px 25px;background:#f5f5f5;border:1px solid #dadada}.AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1 select{display:block;width:100%;height:24px;line-height:24px;background:transparent;border:0;font-weight:400;text-transform:uppercase}.AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1 select:focus{outline:0}.AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1 select::-ms-clear{display:none}.AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J{position:relative}.AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J>button{position:absolute;top:0;right:0;padding:15px}.AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J h5{height:24px;line-height:24px}", ""]);

// exports
exports.locals = {
	"addActivity": "AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1",
	"panelWrapper": "AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/provider/components/AssignRemoveActivityFromProviderContactPopover.less
// module id = 1702
// module chunks = 0